import { useTranslation } from 'react-i18next';

import {
  EditOutlined,
  PictureOutlined,
  ZoomInOutlined,
} from '@ant-design/icons';

import * as St from './ColorOptions.styles';

import { ColorModel } from '~/core/models';
import ActionButton from '~molecules/ActionButton';

interface ColorOptionsProps {
  color: ColorModel;
  handleViewSlabClick: (color: ColorModel) => void;
  handleColorVisualizerChange: () => void;
  handleDesignClick: () => void;
  isVisualizerActive: boolean;
  isSelectedColor: boolean;
}

interface ActionButtonDataWithColorArg {
  id: string;
  title: string;
  icon: React.ComponentType;
  handleClick: (color: ColorModel) => void;
  hasColorArg: true;
}

interface ActionButtonDataWithoutColorArg {
  id: string;
  title: string;
  icon: React.ComponentType;
  handleClick: () => void;
  hasColorArg: false;
}

const ColorOptions = ({
  color,
  handleViewSlabClick,
  handleColorVisualizerChange,
  handleDesignClick,
  isVisualizerActive,
  isSelectedColor,
}: ColorOptionsProps): JSX.Element => {
  const { t } = useTranslation();

  type ActionButtonData =
    | ActionButtonDataWithColorArg
    | ActionButtonDataWithoutColorArg;

  const actionButtonsData: ActionButtonData[] = [
    {
      id: 'zoom',
      title: t('SCROLLABLE_AREA.COLOR.BUTTONS.ZOOM'),
      icon: ZoomInOutlined,
      handleClick: handleViewSlabClick,
      hasColorArg: true,
    },
    {
      id: 'visualize',
      title: t('SCROLLABLE_AREA.COLOR.BUTTONS.VISUALIZE'),
      icon: PictureOutlined,
      handleClick: handleColorVisualizerChange,
      hasColorArg: false,
    },
    {
      id: 'design',
      title: t('SCROLLABLE_AREA.COLOR.BUTTONS.DESIGN'),
      icon: EditOutlined,
      handleClick: handleDesignClick,
      hasColorArg: false,
    },
  ];

  const filteredData = actionButtonsData.filter((data) => {
    if (data.id === 'visualize') {
      return isVisualizerActive;
    } else if (data.id === 'design') {
      return isSelectedColor;
    }

    return true;
  });

  return (
    <St.Container>
      {filteredData.map((data, index) => (
        <ActionButton
          key={`action-button-${index}`}
          title={data.title}
          color={color.overlayColor}
          Icon={(props) => <data.icon {...props} />}
          onClick={() => data.handleClick(color)}
        />
      ))}
    </St.Container>
  );
};

export default ColorOptions;
